import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FAQService {
  faqs$: BehaviorSubject<any>;
  groups$: BehaviorSubject<Object>;

  constructor(private http: HttpClient) { 
    this.faqs$ = new BehaviorSubject(null);
    this.groups$ = new BehaviorSubject(null);
  }

  loadFAQs() {
    this.faqs$.next({"loading":true,data:[]});

    let params = new HttpParams()
    .set('faqType', 'hierarchical')
    

    this.http.get("/api/data/faqs", {params}).subscribe(
      (response: any) => {
        
        // add the dummy initial value
        //let rtn = response;
        //rtn.push({id:0,name:"Initial"})

        this.faqs$.next({"loading":false,data:response});
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get FAQ');
        console.log(error);
      }
    );
  }
  loadGroups() {
    this.groups$.next({"loading":true,data:[]});

    let params = new HttpParams()
    .set('faqType', 'group')

    this.http.get("/api/data/faqs", {params}).subscribe(
      (response: any) => {
        const rtn = response;
        this.groups$.next({"loading":false,data:rtn});
      }, (error: any) => {
        console.log('unable to get group');
        console.log(error);
      }
    );
  }
  createGroup(groupdata){
    return new Promise((resolve) => {
      let body = new HttpParams();
    Object.keys(groupdata).forEach(x => {
      body = body.append(x,groupdata[x]);
    })
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post("api/data/groups", body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {
        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          resolve(response)
          console.log(response)
        }
      }, (error: any) => {
        let message="Unable to create topic"
        resolve(message)
        console.log(message + " > " + JSON.stringify(error));
      }
    );
    })
    

  }
}
